import React, { FC, ReactElement } from 'react'
import useComponentSize from '@/utils/hooks/useComponentSize'
import Grid from './grid'
import Loading from '@/components/circle-loading'
import useBitmap, { HEADER_EVENT, HeaderEvent } from '@/utils/hooks/useBitmap'
import Event from '@/utils/event'

const _ROWS = 1000
const _COLUMNS = 1000
const _HASH_LENGTH = 8

const Bitmap: FC<{ slug: string }> = (props): ReactElement => {
	const { myMap, numMap, idMap, escrowMap, escrows, isLoading, height } = useBitmap(props.slug)
	const { width, ref } = useComponentSize()
	const [tab, setTab] = React.useState('show-all')
	const [rowIndex, setRowIndex] = React.useState(0)
	const [columnIndex, setColumnIndex] = React.useState(0)

	React.useEffect(() => {
		const handleEvent = (e: HeaderEvent) => {
			if (e?.tab) {
				setTab(e.tab)
			}

			if (e?.block) {
				const row = Math.floor(e.block / 1000)
				const col = e.block % 1000

				setColumnIndex(col)
				setRowIndex(row)
			}
		}

		Event.listen(HEADER_EVENT, handleEvent)

		return () => {
			Event.removeListener(HEADER_EVENT, handleEvent)
		}
	}, [])

	return (
		<div ref={ref}>
			{isLoading && (
				<div className="flex justify-center items-center h-[25vh]">
					<Loading />
				</div>
			)}
			{!isLoading && width && (
				<Grid
					tab={tab}
					height={height}
					width={width}
					numMap={numMap}
					idMap={idMap}
					myMap={myMap}
					escrowMap={escrowMap}
					escrows={escrows}
					rowIndex={rowIndex}
					columnIndex={columnIndex}
					slug={props.slug}
				/>
			)}
		</div>
	)
}

export default Bitmap
